module.exports = __webpack_public_path__ + "media/hyper/images/ico-messenger-4f203f9717f1eec76333420dc860c4ab.png";